export function validateEmail(email) {
  if (email === null) {
    return false;
  }
  return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);
}

export function validatePassword(password) {
  if (password === null) {
    return false;
  }
  return password.length >= 6;
}

export function trimString(string) {
  if (string === null) {
    return null;
  } else if (string.length === 0) {
    return null;
  } else if (string.replaceAll(" ", "").length === 0) {
    return null;
  } else {
    return string;
  }
}
